export function formatDate(date) {
  if (!date) return '';

  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const dateObj = new Date(date * 1000); // assumes Unix timestamp

  if (isNaN(dateObj)) return '';

  return `${dateObj.getDate()} ${months[dateObj.getMonth()]} ${dateObj.getFullYear()}`;
}

export function formatFileSize(fileSize) {
  const thresh = 1024;
  if (Math.abs(fileSize) < thresh) {
    return `${fileSize} B`;
  }

  const units = ['KB', 'MB', 'GB'];
  let u = -1;

  do {
    fileSize /= thresh;
    ++u;
  } while (Math.abs(fileSize) >= thresh && u < units.length - 1);

  return `${fileSize.toFixed(1)} ${units[u]}`;
}

export function extractFormData(tile, registrationFormType) {
  let addTypes = [],
    forms = [],
    formsHasActions = false,
    completedForms = [],
    completedFormsHasFile = false,
    completedFormsHasPdf = false;
  for (let i = 0, ii = tile.formTypes.length; i < ii; i++) {
    if (tile.formTypes[i].id !== registrationFormType && tile.formTypes[i].canAdd) {
      addTypes.push(tile.formTypes[i]);
    }
    for (let j = 0, jj = tile.formTypes[i].forms.length; j < jj; j++) {
      let form = tile.formTypes[i].forms[j];
      form.formType = tile.formTypes[i].id;
      forms.push(form);
      if (form.canDelete) {
        formsHasActions = true;
      }
    }
    for (let j = 0, jj = tile.formTypes[i].completedForms.length; j < jj; j++) {
      let completedForm = tile.formTypes[i].completedForms[j];
      completedForm.files = [];
      completedForm.renderedPdf = null;
      if (typeof completedForm.attachments === 'undefined') {
        completedForm.attachments = [];
      }
      for (let i = 0, ii = completedForm.attachments.length; i < ii; i++) {
        if (completedForm.attachments[i].type === 'form') {
          completedForm.renderedPdf = completedForm.attachments[i];
          completedFormsHasPdf = true;
        } else {
          if (completedForm.attachments[i].type === 'invoice') {
            completedForm.attachments[i].iconClass = 'sa-invoice';
          } else {
            completedForm.attachments[i].iconClass = 'sa-pdf';
          }
          completedForm.files.push(completedForm.attachments[i]);
          completedFormsHasFile = true;
        }
      }
      completedForms.push(completedForm);
    }
  }
  return { addTypes, forms, formsHasActions, completedForms, completedFormsHasFile, completedFormsHasPdf };
}
